import { Setting, Settings } from "../../types";
import {
  addSetting,
  deleteSetting,
  deleteSettings,
  setSettings,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

const useSettings = () => {
  const settingsState = useSelector((state: any) => state.settings);
  const [storedSettings, setStoredSettings] = useState<Settings | null>(
    settingsState
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setStoredSettings(settingsState);
  }, [settingsState]);

  const writeSettings = (_settings: Settings) => {
    dispatch(setSettings(_settings));
  };

  const removeSettings = () => {
    dispatch(deleteSettings());
  };

  const writeSetting = (_setting: Setting) => {
    dispatch(addSetting(_setting));
  };

  const removeSetting = (_setting: string) => {
    dispatch(deleteSetting(_setting));
  };

  return {
    settings: storedSettings,
    removeSettings,
    removeSetting,
    writeSetting,
    writeSettings,
  };
};

export default useSettings;
